import { MenuItemsModel } from '@core/menu/menu.model';
import { RouteEntity } from '@core/router/route.entity';
import { PrivilegesModules } from '@core/privileges/privileges-modules';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RoutingQueryParamsName } from '@core/router/routing.params';


export const submenu: MenuItemsModel[] = [
    {
        mdId: 1,
        mdName: marker('modules.parameters.head'),
        url: RouteEntity.Root + RouteEntity.Parameters,
        objName: [PrivilegesModules.SysadmParams],
    },
    {
        mdId: 2,
        mdName: marker('modules.appearance.head'),
        url: RouteEntity.Root + RouteEntity.Appearance,
        objName: [PrivilegesModules.SysadmAppearance],
    },
];

export const thirdLevelMenu: { [key: string]: MenuItemsModel[] } = {
    appearance: [
        {
            mdId: 1,
            mdName: marker('sysadm.submenu.appearance.appearance-versions'),
            url:
                RouteEntity.Root +
                RouteEntity.Appearance +
                '/' +
                RouteEntity.Design,
        },
        {
            mdId: 2,
            mdName: marker('sysadm.submenu.appearance.advertising'),
            url:
                RouteEntity.Root +
                RouteEntity.Appearance +
                '/' +
                RouteEntity.Advertising,
        },
    ],
    design: [
        {
            mdId: 1,
            mdName: marker('global.labels.info'),
            urlTemplate:
                RouteEntity.Root +
                RouteEntity.Appearance +
                '/' +
                RouteEntity.Design +
                '/#' + RoutingQueryParamsName.VersionId + '#/' +
                RouteEntity.About,
        },
        {
            mdId: 2,
            mdName: marker('global.labels.designElements'),
            urlTemplate:
                RouteEntity.Root +
                RouteEntity.Appearance +
                '/' +
                RouteEntity.Design +
                '/#' + RoutingQueryParamsName.VersionId + '#/' +
                RouteEntity.Elements,
        },
    ],
};
